export default __webpack_public_path__ + "static/racing-tracks-mix-80da516f23d79728c84cb6bac8933697.jpg";